<template>
    <div class="brt-footer-line">
        <span>{{ content }}</span>
    </div>
</template>

<script>
    export default {
        name: "FooterLine",
        props: {
            content: {
                default: '我是有底线的'
            }
        }
    }
</script>

<style lang="less">

    @import "../../styles/comm.less";

    .brt-footer-line {
        text-align: center;
        color: fade(@fontColorA3, 65%);
        font-size: @28px;
        position: relative;
        padding: @spacingNumber 0;

        &:after,
        &:before {
            content: '';
            position: absolute;
            top: 50%;
            left: 20%;
            right: 20%;
            border-top: 1px solid @borderColorA1;
            z-index: 1;
        }

        > span {
            display: inline-block;
            background-color: @bodyBgColor;
            padding: 0 @15px;
            position: relative;
            z-index: 2;
        }
    }

</style>
